import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app';
import { APP_CONFIG } from './config';
import { createQueryClient } from './api/query-client';
import { platform } from './platform';
import { createAppRouter } from './router';
import './styles.css';

document.title = APP_CONFIG.SITE_TITLE;

/*
 * Alternative stylesheet (styles.css, themes/*.css). `?theme=modern|nordic|high-contrast` picks one
 * and remembers it; `?theme=legacy` (or any other value) returns to the default look. Set as
 * `data-style`, not `data-theme`: the platform owns `data-theme` (the user's global preference,
 * useConfigurationTheme) and overwrites it on load.
 */
const THEMES = ['modern', 'nordic', 'high-contrast'];
const requestedTheme = new URLSearchParams(window.location.search).get('theme');
if (requestedTheme !== null) localStorage.setItem('dealer-portal.theme', requestedTheme);
const theme = localStorage.getItem('dealer-portal.theme');
if (theme && THEMES.includes(theme)) document.documentElement.dataset.style = theme;

const queryClient = createQueryClient();
const router = createAppRouter(queryClient);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App queryClient={queryClient} platform={platform} router={router} />
  </StrictMode>,
);
